import React, { useState, useCallback, useEffect } from "react";
import { withFormik } from 'formik';
import * as Yup from "yup";
import moment from "moment"
import { useTranslation } from 'react-i18next';
import { useStoreState, useStoreActions } from 'easy-peasy';

import { Button, Typography, Spinner } from "stories/components";
import { Container, Row, Col, FormContainer, Card, CardBody } from "stories/layout";
import { Input, SelectMulti, Toggle, Radio, DatePicker } from "stories/forms";
import { useNotification } from "stories/components/Notification"
import CurrencySelect from "components/Forms/CurrencySelect/CurrencySelect"
import InvestmentTypeSelectSub from "components/Forms/InvestmentTypeSelectSub/InvestmentTypeSelectSub"



import { httpGetDividend, httpCreateDividend, httpUpdateDividend, httpDeleteDividend} from "services/dividends"
import { useAppDialog } from "components/AppDialog/useAppDialog"

const defaultValues = {
  id: null,
  name: "",
}

const PrivateInvestmentFundEdit = (props) => {
  const { dialog, confirm } = useAppDialog();
  
  const {
     values,
     touched,
     setTouched,
     errors,
     setErrors,
     handleChange,
     handleBlur,
     handleSubmit,
     setFieldValue,
     isValid,
     isTouched,
     isSubmitting,
     validateForm,
     preSetValues
   } = props;
   
   const {
      t,
      history,
      objectId,
      related_model_type,
      currency_label,
      getUnmadeDividendTransactions

   } = props;
   
   const getFormikInputProps = useCallback(
    name => ({
      name,
      value: values[name],
      error: Boolean(touched[name] && errors[name]),
      errorText: touched[name] ? errors[name] : "",
      onBlur: handleBlur,
      onChange: handleChange
    }),
    [values, errors, touched, handleBlur, handleChange]
  );
  


  const onSubmit = (e) => {
    e.preventDefault();
    validateForm().then(res => {
      if (Object.keys(res).length === 0) {
        handleSubmit()
      }
      else {
        setTouched(res);
        setErrors({
          ...res,
          general: t("Please check the form errors", "Tarkista lomakkeen virheet")
        })
      }
    })
  }
  
  const handleCancel = () => {
    props.handleReject()
  }
  
  const handleDelete = () => {
    confirm(t("are_you_sure_window_confirm","Oletko varma?")).then((result) => {
      if (result) {
        httpDeleteDividend(objectId).then(() => {
          getUnmadeDividendTransactions()
          props.handleResolve()
        })
      }
    });
  }
  
  return (
    <>
    {dialog}
    {/* {JSON.stringify(related_model_type)}
    {JSON.stringify(currency_label)} */}
    {/* {JSON.stringify(values)} */}
      <Row>
        <Col className="mb-3">
          <DatePicker
            {...getFormikInputProps("ex_date")}
            label={t("private_investment_divident_ex_date", "Irtoamispäivä")}
            className="form-control"
            selected={values?.ex_date}
            name="ex_date"
            onChange={(date) => setFieldValue("ex_date", date)}
            showYearDropdown
            dateFormat="d.M.yyyy"
            value={values?.ex_date}
            disabled= {objectId? true : false}
            required
          />
        </Col>
      </Row>
      <Row>
        <Col className="mb-3">
          <DatePicker
            {...getFormikInputProps("pay_date")}
            label={t("private_investment_divident_pay_date", "Maksupäivä")}
            className="form-control"
            selected={values?.pay_date}
            name="pay_date"
            onChange={(date) => setFieldValue("pay_date", date)}
            showYearDropdown
            dateFormat="d.M.yyyy"
            value={values?.pay_date}
            disabled= {objectId? true : false}
            required
          />
        </Col>
      </Row>
      <Row>
        <Col className="mb-3">

          <Input
          {...getFormikInputProps("rate")}
          label={t("dividend_rate_per_share", "Osinko/osake")}
          type="number"
          min={0}
          step={"0.01" }
          onWheel={(e) => e.target.blur()}
          placeholder={t("0")}
          disabled= {objectId? true : false}
        />
        </Col>
      </Row>
   
      
      
      <Row>
        <Col className="mb-3">
          <CurrencySelect 
            {...getFormikInputProps("currency_label")} 
            label={t("PrivateInvestmentFundEdit_currency", "Valuutta")}
            value={currency_label}
            required
            disabled={objectId? true: false}
            // disabled={true}

          />
          {/* { !objectId &&
            <Typography variant="small">{t("Valuutta tietoa ei voi muokata myöhemmin")} </Typography>
          } */}
          
        </Col>
      </Row>
      
      
      <Row>
        <Col className="mb-3">
          <Button onClick={handleCancel} variant="secondary" className="sk-modal-dismiss">{t("Close","Sulje")}</Button>
        </Col>
        { values?.id ? (
        <Col className="mb-3 text-center">
          <Button onClick={handleDelete} variant="danger">{t("Delete","Poista")}</Button>
        </Col>
        ) : null }
        <Col className="mb-3 text-right">

            <Button variant="primary" disabled={isSubmitting} onClick={onSubmit}>
              {t("Save","Tallenna")}
            </Button>
          
          { Boolean(errors["general"]) && <Typography className="text-danger">{errors["general"]}</Typography> }
        </Col>
      </Row>
        
    </>
  );
}

const PrivateInvestmentFundEditFormik = withFormik({
    enableReinitialize: true,
    validateOnMount: true,
    mapPropsToValues: props => {
      const { preSetValues } = props;
      if ( preSetValues) {
        return preSetValues;
      } else {
        return {
          ...defaultValues
        }
      }
    },
    validationSchema: props => {
      const {t} = props;
      const required = t("The field is required");
      return Yup.object().shape({
        ex_date: Yup.date().required(required),
        pay_date: Yup.date().required(required),
        rate: Yup.number().required(required),

      });
    },
    handleSubmit: (values, { setSubmitting, setErrors, props }) => {
      const {t, portfolio,related_model_id,related_model_type, account} = props;
      const oldDate = values.ex_date;
      const newDate = new Date(oldDate.getFullYear(), oldDate.getMonth(), oldDate.getDate(), 12, 0, 0);
      const formattedDate = newDate.toISOString().split('T')[0] +" 12:00:00Z";;
      const ex_date = formattedDate;

      const old_pay_date = values.pay_date;
      const new_pay_date = new Date(old_pay_date.getFullYear(), old_pay_date.getMonth(), old_pay_date.getDate(), 12, 0, 0);
      const formatted_pay_date = new_pay_date.toISOString().split('T')[0] +" 12:00:00Z";;
      const pay_date = formatted_pay_date;
      
      

      const values_price = values?.price ? parseFloat(values?.price.toString().replace(",",".")) : 0;
      let data = {
        ...values,
        ex_date: ex_date,
        pay_date: pay_date,
        price: values_price,
        related_model_id: related_model_id,
        related_model_type: related_model_type, //Private investmentFund
        account: account.id,
        type: 2,
        updated_security_ratios: true,
        split_scope: values?.split_scope
      };
      
      const handleApiError = (error) => {
        setSubmitting(false);
        const data = error?.data;
        if (data?.detail) {
          setErrors({ general: data.detail });
          return;
        }
        if (data && typeof data === 'object') {
          const fieldErrors = {};
          Object.entries(data).forEach(([key, value]) => {
            if (key === 'errorCode') return;
            const text = Array.isArray(value) ? value.join(' ') : String(value);
            if (key === 'non_field_errors') {
              fieldErrors.general = text;
            } else {
              fieldErrors[key] = text;
            }
          });
          if (!fieldErrors.general && Object.keys(fieldErrors).length > 0) {
            fieldErrors.general = t("form_has_field_errors", "Tarkista lomakkeen kenttävirheet");
          }
          if (Object.keys(fieldErrors).length > 0) {
            setErrors(fieldErrors);
            return;
          }
        }
        setErrors({
          general: t("Unknown error. Please try again later or contact support.")
        });
      };

      if (values?.id) {
        httpUpdateDividend(values.id, data).then(res => {
          setSubmitting(false);
          props.notify({ title:t("dividend_notify_title", "Osinko"), message:t("Updated")})
          props.getUnmadeDividendTransactions()

          props.handleResolve()

        }, handleApiError)
      }
      else {
        httpCreateDividend(data).then(res => {
          setSubmitting(false);
          props.notify({ title:t("dividend_notify_title", "Osinko"), message:t("Created")})
          props.getUnmadeDividendTransactions()

          props.handleResolve()

        }, handleApiError)
      }
      
      
    },
    displayName: "BasicForm"
  
})(PrivateInvestmentFundEdit)
    
    
const PrivateInvestmentFundEditView = ({history, objectId, modalOpen, ...rest}) => {
  // API requests here
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [preSetValues, setPreSetValues] = useState();
  const { notify } = useNotification(); // import { useNotification } from "stories/components/Notification"
  const account = useStoreState((state) => state.account?.account);
  const getUnmadeDividendTransactions = useStoreActions((actions) => actions.unmadeDividendTransactions.getUnmadeDividendTransactions);

  
  
  const getObject = (id) => {
    
    setLoading(true)
    
    httpGetDividend(id).then(res => {
      
      setPreSetValues({
        ...defaultValues,
        ...res?.data,
        ex_date: res?.data?.ex_date ? moment(res?.data?.ex_date).toDate() : null,
        pay_date: res?.data?.pay_date ? moment(res?.data?.pay_date).toDate() : null,
        
        // // ex_date: res?.data?.ex_date ? new Date(): new Date(),
        // // pay_date: res?.data?.pay_date ? new Date() : new Date(),
      });
    
    }).finally(response => {
      setLoading(false);
    })
    
  }
  
  
  useEffect(() => {
    if (objectId && parseInt(objectId) > -1) {
      getObject(objectId)
    }
    else{
      setPreSetValues({
        ...defaultValues,
        currency_label: rest?.currency_label,
      });
    }
  }, [objectId, modalOpen])
  
  
  if (loading) {
    return (
      <Container fluid>
        <Spinner />
      </Container>
    )
  }

  return (
    <PrivateInvestmentFundEditFormik 
      t={t} 
      history={history} 
      preSetValues={preSetValues} 
      notify={notify} 
      objectId={objectId}
      account={account}
      getUnmadeDividendTransactions={getUnmadeDividendTransactions}

      {...rest} 
    />
  )
  
}

export default PrivateInvestmentFundEditView;
